import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { Autocomplete, TextField, IconButton, Typography } from "@totalsoft/rocket-ui";
import { clone } from "ramda";

const PartnerAssociationFilterComponent = ({ filterList, setFilterList }) => {
  const { t } = useTranslation();

  return (
    <Grid container item xs={12} spacing={2}>
      {filterList.map((item, idx) => (
        <Grid container item key={idx} alignItems="center" spacing={2}>
          <Grid item xs={1}>
            <Typography>{idx === 0 ? "Where" : "Or"}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Autocomplete
              fullWidth
              simpleValue
              label={t("PartnerHierarchy.PartnerAssociationModal.FilterBy")}
              options={[
                { id: 1, name: t("Partner.Name") },
                { id: 2, name: t("Partner.UniqueID") }
              ]}
              value={item.id}
              onChange={val =>
                setFilterList(prev => {
                  const newList = clone(prev);
                  newList[idx].id = val;
                  return newList;
                })
              }
            />
          </Grid>
          <Grid item xs={1}>
            <Typography>{"Contains"}</Typography>
          </Grid>
          <Grid item xs={5}>
            <TextField
              label={t("PartnerHierarchy.PartnerAssociationModal.FilterValue")}
              fullWidth
              value={item.value}
              onChange={val =>
                setFilterList(prev => {
                  const newList = clone(prev);
                  newList[idx].value = val;
                  return newList;
                })
              }
            />
          </Grid>
          <Grid item xs={1}>
            {idx !== filterList.length-1 ? (
              <IconButton
                tooltip={t("PartnerHierarchy.PartnerAssociationModal.RemoveFilter")}
                onClick={() => setFilterList(prev => prev.filter((_, index) => index !== idx))}
                color="transparent"
                type="delete"
              />
            ) : (
              <IconButton
                tooltip={t("PartnerHierarchy.PartnerAssociationModal.AddFilter")}
                onClick={() => {
                  setFilterList(prev => {
                    const newList = [...prev];
                    newList.push({ id: null, value: "" });
                    return newList;
                  });
                }}
                color="transparent"
                type="add"
              />
            )}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

PartnerAssociationFilterComponent.propTypes = {
  filterList: PropTypes.array.isRequired,
  setFilterList: PropTypes.func.isRequired
};

export default PartnerAssociationFilterComponent;
